module.exports = __webpack_public_path__ + "static/img/rejected.88fd53e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rejected.png
// module id = mspy
// module chunks = 1